import React, { useEffect, useState } from 'react';
import { Folha } from '../../componentes/folha/folha';
import { Button, Input, Col, Row, Form, notification } from 'antd'
import { useAxios } from '../../hooks';

const { TextArea } = Input;

const TermosOS = () => {

    const { getApiEmitirNotas } = useAxios();
    const [termos, setTermos] = useState('');

    useEffect(() => {
        const init = async () => {
            const api = await getApiEmitirNotas();
            const result = await api.get('/pedidos/termos-uso');
            setTermos(result.data.termos);
        }
        init();
    }, []);

    const salvar = async () => {
        try {
            const api = await getApiEmitirNotas();
            const result = await api.post('/pedidos/termos-uso', { termos: termos });
            notification.success({
                message: 'Sucesso',
                description: 'Termos salvo com sucesso.'
            })

        } catch (error) {
            notification.error({
                message: 'Desculpe, Houve um erro',
                description: 'Tente novamente, se o problema persistir por favor entre em contato com nosso suporte.'
            })
            console.log('erro ao salvar termos: ',error);
        }
    }

    return (
        <Folha>
            <Form onFinish={salvar}>
                <Row key={1} style={{ borderBottom: "solid 3px #1a4f81" }} justify="space-between">
                    <Col key={2} span={12}><h1 style={{ textAlign: "left" }}>Digite os termos da OS abaixo:</h1> </Col>

                </Row>
                <Row>
                    <Col sm={24} style={{ marginTop: "10px" }}>
                        <TextArea name="textAreaTermos" rows={12} value={termos} onChange={(e) => { setTermos(e.target.value) }} />
                    </Col>
                </Row>
                <Row>
                    <Col sm={24} style={{ textAlign: "right", marginTop: "10px" }}>
                        <Button type="primary" htmlType='submit'>Salvar</Button>
                    </Col>
                </Row>
            </Form>
        </Folha>
    )
}

export { TermosOS }